export const ANIMAL_LIST_URL        = 'animal/list'
export const ANIMAL_LIST_ERROR      = 'ANIMAL_LIST_ERROR'
export const ANIMAL_LIST_LOADING    = 'ANIMAL_LIST_LOADING'
export const ANIMAL_LIST_SUCCESS    = 'ANIMAL_LIST_SUCCESS'

export const ANIMAL_PAGE_URL        = 'animal/page'
export const ANIMAL_PAGE_ERROR      = 'ANIMAL_PAGE_ERROR'
export const ANIMAL_PAGE_LOADING    = 'ANIMAL_PAGE_LOADING'
export const ANIMAL_PAGE_SUCCESS    = 'ANIMAL_PAGE_SUCCESS'

export const ANIMAL_VIEW_URL        = 'animal/view'
export const ANIMAL_VIEW_ERROR      = 'ANIMAL_VIEW_ERROR'
export const ANIMAL_VIEW_LOADING    = 'ANIMAL_VIEW_LOADING'
export const ANIMAL_VIEW_SUCCESS    = 'ANIMAL_VIEW_SUCCESS'

export const ANIMAL_ADD_URL        = 'animal/save'
export const ANIMAL_ADD_ERROR      = 'ANIMAL_ADD_ERROR'
export const ANIMAL_ADD_LOADING    = 'ANIMAL_ADD_LOADING'
export const ANIMAL_ADD_SUCCESS    = 'ANIMAL_ADD_SUCCESS'

export const ANIMAL_DELETE_URL        = 'animal/delete'
export const ANIMAL_DELETE_ERROR      = 'ANIMAL_DELETE_ERROR'
export const ANIMAL_DELETE_LOADING    = 'ANIMAL_DELETE_LOADING'
export const ANIMAL_DELETE_SUCCESS    = 'ANIMAL_DELETE_SUCCESS'

export const ANIMAL_UPDATE_URL        = 'animal/update'
export const ANIMAL_UPDATE_ERROR      = 'ANIMAL_UPDATE_ERROR'
export const ANIMAL_UPDATE_LOADING    = 'ANIMAL_UPDATE_LOADING'
export const ANIMAL_UPDATE_SUCCESS    = 'ANIMAL_UPDATE_SUCCESS'